import { render, staticRenderFns } from "./medicineDetails.vue?vue&type=template&id=6c46e921&scoped=true&"
import script from "./medicineDetails.vue?vue&type=script&lang=js&"
export * from "./medicineDetails.vue?vue&type=script&lang=js&"
import style0 from "./medicineDetails.vue?vue&type=style&index=0&id=6c46e921&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c46e921",
  null
  
)

export default component.exports